module.exports = __webpack_public_path__ + "static/media/spacelegend.8476ee76.png";